import { useMemo } from 'react';
import { toDateOrNull, formatDateRange } from 'src/helpers/date-helpers';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { RPDF } from 'src/features/report/react-pdf';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { FormDateInputComponent } from 'src/features/generalForms/builder/types/DateInput';

export const FormDateRangeInput: FormDateInputComponent = (props) => {
  const [from, to] = useAnswerValue(props.dataKey!) ?? [];
  const isEmpty = useMemo(() => !toDateOrNull(from) && !toDateOrNull(to), [from, to]);

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return (
    <AnswerPreviewRow<(Date | undefined)[]>
      value={isEmpty ? undefined : [toDateOrNull(from) ?? undefined, toDateOrNull(to) ?? undefined]}
      renderValue={([f, t]) => formatDateRange(f, t)}
      isOptional={props.endDateIsOptional && props.startDateIsOptional}
      {...props}
    />
  );
};
